// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/sass/app.scss
// module id = kvjP
// module chunks = 4